import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import firebase from 'firebase/compat'
import firestore = firebase.firestore
import { enquiriesPath, Enquiry } from '@parkupp/core'
import { addDoc, collection, serverTimestamp } from '@angular/fire/firestore'
import { ClientService } from '../../../services/client.service'
import { ActivatedRoute, Router } from '@angular/router'
import { LazyLoaderService } from '../../../services/lazy-loader.service'

@Component({
    selector: 'app-bookupp-info-page',
    templateUrl: './bookupp-info-page.component.html',
    styleUrls: ['./bookupp-info-page.component.scss'],
})
export class BookuppInfoPageComponent implements OnInit {
    formGroup: FormGroup
    formLoading = false
    formError = ''
    enquiry: Enquiry
    formComplete = false
    merchantFaqs: any[] = []

    constructor(private fb: FormBuilder, private clientService: ClientService, private router: Router, private activatedRoute: ActivatedRoute, private lazyLoaderService: LazyLoaderService) {
        if (this.activatedRoute.snapshot.paramMap.get('status')) {
            this.formComplete = true
        }

        this.enquiry = new Enquiry()

        this.formGroup = this.fb.group({
            name: [''],
            email: [''],
            phone: [''],
            location: [''],
            company: [''],
            type: ['BookUpp Enquiry'],
        })
    }

    ngOnInit(): void {
        this.merchantFaqs.push({
            question: `How can I list my parking on ParkUpp`,
            answer: `We have built the site to be quite intuitive, please click on “list a parking” on our website and follow the process. Please contact us should you require assistance.`,
        })
        this.merchantFaqs.push({
            question: `How long can I list my parking for?`,
            answer: `ParkUpp Monthly - You can list your parking for a minimum period of one month. Parkers using
            ParkUpp monthly prefer a 6 - 12 month contract.
            <br><br>
            ParkUpp Events - You can list available parking for the day of a specific event.
            <br><br>
            ParkUpp Flex - This allows you to list your parking in a vacant building one month at a time allowing you to end all contracts before your new tenant moves in. Parkers will submit a new parking reservation request one month at a time.
            <br><br>
            ParkUpp Collector  - You can list your parking for a minimum period of one month. Parkers using
            ParkUpp Collector prefer a 6 - 12 month contract.`,
        })
        this.merchantFaqs.push({
            question: `How should I price my listing on ParkUpp?`,
            answer: `We recommend that your parking fee be in line with competing parking in your area. Obviously the cheaper the more likely you are to attract parkers. Please contact us if we can assist.`,
        })
        this.merchantFaqs.push({
            question: `When will I get paid?`,
            answer: `ParkUpp collects parking fees through our Paygate infrastructure and pays to parking owners the received fee less ParkUpps service percentage on the 7th of the following month. Please contact us should require an alternate arrangement.`,
        })
        this.merchantFaqs.push({
            question: `What is ParkUpp’s service fee?`,
            answer: `ParkUpp charges 15% of the parking rental. The ParkUpp fee includes costs associated with payment systems, marketing and administration.
            <br><br>
            Example: if you choose to rent your parking bay out for R800 a month, ParkUpp will charge R120 every month for the duration of the contract. R 680 will be transferred to the property owner by the 7th of the following month, each month, until the contract expires.`,
        })
        this.merchantFaqs.push({
            question: `How can I get further assistance?`,
            answer: `Please reach out to the below:
            <br><br>
            Kwanele Tshabalala - kwanele@parkupp.co.za
            <br>
            Umar Obaray - umar@parkupp.co.za`,
        })
    }

    onSubmit() {
        this.formLoading = true
        // this.formError = ''

        this.enquiry.patch(this.formGroup.value)
        this.enquiry.createdAt = serverTimestamp() as firestore.Timestamp
        console.log(this.enquiry)

        addDoc(collection(this.clientService.firestore, enquiriesPath()), this.enquiry.parse()).then(() => {
            this.formLoading = false
            this.router.navigate([`/bookupp/complete`])
            return
        })
    }

    listParking() {
        this.router.navigate(['/sign-up'])
    }
}
